import L from 'leaflet';

export const mapUtils = {
  rotate,
  getAngle,
  iconCreateFunction,
  setSingleMarker,
  getLastPositionsLayer,
  getHistoryPositionsLayer
}

function rotate(degrees) {
  return 'style="-webkit-transform: rotate('+degrees+'deg); '+
    '-moz-transform: rotate('+degrees+'deg); ' +
    '-ms-transform: rotate('+degrees+'deg); ' +
    '-o-transform: rotate('+degrees+'deg); ' +
    'ransform: rotate('+degrees+'deg); ' +
    'zoom:1;"';
}

function getAngle(layer0, layer1) {
  var p0 = L.Projection.Mercator.project(layer0.getLatLng());
  var p1 = L.Projection.Mercator.project(layer1.getLatLng());
  var rad = Math.atan2(p1.y - p0.y, p1.x - p0.x);
  return -1* rad * (180/Math.PI) + 90;
}

function iconCreateFunction(cluster) {
  var markers = cluster.getAllChildMarkers();

  var c = ' marker-cluster-1';
  var child = cluster.getChildCount() == 1 ? "" : cluster.getChildCount();

  // STOP
  var predicateStop = function(marker) {
    return marker.feature && marker.feature.properties && marker.feature.properties.stopDuration;
  };
  if (markers.find(predicateStop)) {
    c = cluster.getChildCount() > 1 ? ' marker-cluster-2' : ' stop';
    var span = '<span>';
    // if (cluster.getChildCount() == 1)
    //     span = '<span class="icon-stop2 fa-3x" style="color:red;">';
    return new L.DivIcon({ html: '<div>' + span + child + '</span></div>', className: 'marker-cluster' + c, iconSize: new L.Point(40, 40) });
  }

  var arrow = cluster.getChildCount() == 1 ? '<div class="marker-arrow" '+ rotate(markers[0].feature.properties.angle)+'></div>' : '';
  return new L.DivIcon({ html: '<div>' + arrow + '<span>' + child + '</span></div>', className: 'marker-cluster' + c, iconSize: new L.Point(40, 40) });
}

function setSingleMarker(map, layer, feature) {
  if (layer) {
    map.removeLayer(layer);
    layer = undefined;
  }
  if (feature && feature.geometry && feature.geometry.coordinates) {
    layer = L.featureGroup();
    let latLon = {lng: feature.geometry.coordinates[0], lat: feature.geometry.coordinates[1]};
    let pos = L.marker(latLon);
    layer.addLayer(pos);
    map.addLayer(layer);
    map.panTo(new L.LatLng(latLon.lat, latLon.lng));
  }
  return layer;
}

function getLastPositionsLayer(positions, map, clickHandler, autoZoom) {
  if (positions.length == 0) {
    return
  }
  // var that = this;
  var jsonLayer = L.geoJson(positions, {
    onEachFeature: function (feature, layer) {
      layer.on('click', function() {
        // eslint-disable-next-line
        // console.log("onclick", this);
        if (this && this.feature) {
          clickHandler(this.feature);
        }
      })
    },
    pointToLayer: function(feature, latlng) {
      return L.marker(latlng,{
        icon: L.icon({iconUrl: require('./vehicle.png'), iconSize: [32, 32]})
      });
    }
  })
  if (autoZoom) {
    map.fitBounds(jsonLayer.getBounds(),{maxZoom: 10, padding:[15,15]});
  }
  var _lastPositionsLayer = new L.MarkerClusterGroup({
    showCoverageOnHover: false,
    removeOutsideVisibleBounds: true,
    spiderfyOnMaxZoom: true,
    maxClusterRadius: 40,
    singleMarkerMode: false
  });
  jsonLayer.addTo(_lastPositionsLayer);
  _lastPositionsLayer.addTo(map);
  return _lastPositionsLayer;
}

function getHistoryPositionsLayer(positions, posLayer, map, clickHandler) {
  if (positions.length == 0) {
    return
  }
  var mergedLayer = L.geoJson(positions, {
    onEachFeature: function (feature, layer) {
      if(posLayer.length){
        var layer0 = posLayer[posLayer.length-1];
        if (!(layer0.feature.properties.angle)){
          layer0.feature.properties.angle =  mapUtils.getAngle(layer0, layer);
        }
      }
      posLayer.push(layer);
      layer.on('click', function() {
        // eslint-disable-next-line
        // console.log("onclick", this);
        if (this && this.feature) {
          clickHandler(this.feature);
        }
      })
    },
  })
  map.fitBounds(mergedLayer.getBounds(),{maxZoom: 10, padding:[15,15]});
  var _historyPositionsLayer = new L.MarkerClusterGroup({
    showCoverageOnHover: false,
    removeOutsideVisibleBounds: true,
    spiderfyOnMaxZoom: true,
    maxClusterRadius: 40,
    singleMarkerMode: true,
    iconCreateFunction: iconCreateFunction
  });
  mergedLayer.addTo(_historyPositionsLayer);
  _historyPositionsLayer.addTo(map);
  return _historyPositionsLayer;
}
